import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PricingCalculatorCard, { PricingCardListItem } from '.';
import { RadioGroup } from '../Radio';

const PricingCalculatorCardDemo = () => {
  const [value, setValue] = React.useState<string | number>(0);
  const [listItems1, setListItems1] = useState<Array<PricingCardListItem>>([
    {
      text: 'lorem ipsum',
      value: 123,
    },
    {
      text: 'lorem ipsum',
      value: 123,
    },
  ]);
  const [listItems2, setListItems2] = useState<Array<PricingCardListItem>>([
    {
      text: '',
      value: undefined,
    },
  ]);

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  const handleInputValueChange = (
    value: number | undefined,
    listItems: Array<PricingCardListItem>,
    setListItems: Function
  ) => {
    let listItemsNew = listItems;
    if (listItemsNew[0]) {
      listItemsNew[0].value = value;
    } else {
      listItemsNew[0] = {
        text: '',
        value: value,
      };
    }
    setListItems(listItemsNew);
  };

  const handleChangeListItems1 = (value: number | undefined) => {
    handleInputValueChange(value, listItems1, setListItems1);
  };
  const handleChangeListItems2 = (value: number | undefined) => {
    handleInputValueChange(value, listItems2, setListItems2);
  };
  return (
    <Container>
      <Container className="mt-10 pb-10 pt-10">
        <RadioGroup
          name={'pricing-test1'}
          value={value}
          onChange={handleChange}
        >
          <Row>
            <h4>Pricing Calculator Cards</h4>
            <Col className="mt-10 col-12">
              <PricingCalculatorCard
                title="HMO Plan"
                subtitle={
                  <div>
                    <b>Annual Contribution</b> Range $120 - $7,100
                  </div>
                }
                listItems={listItems2}
                handleChange={handleChangeListItems2}
                radioButtonValue={7}
                selected={value === 7}
              />
            </Col>
            <Col className="mt-10 col-12">
              <PricingCalculatorCard
                title="Lorem ipsum"
                subtitle={
                  <div>
                    <b>Annual Contribution</b> Range $120 - $7,100
                  </div>
                }
                radioButtonValue={8}
                selected={value === 8}
                listItems={listItems1}
                handleChange={handleChangeListItems1}
              />
            </Col>
            <Col className="mt-10 col-12">
              <PricingCalculatorCard
                title="Lorem ipsum"
                subtitle={
                  <div>
                    <b>Annual Contribution</b> Range $120 - $7,100
                  </div>
                }
                radioButtonValue={8}
                selected={value === 8}
                listItems={listItems1}
                handleChange={handleChangeListItems1}
                resultOnly
              />
            </Col>
            <Col className="mt-10 col-12">
              <PricingCalculatorCard
                title="Lorem ipsum"
                subtitle={
                  <div>
                    <b>Annual Contribution</b> Range $120 - $7,100
                  </div>
                }
                radioButtonValue={8}
                selected={value === 8}
                listItems={listItems1}
                handleChange={handleChangeListItems1}
                isCollapsedView
              />
            </Col>
          </Row>
        </RadioGroup>
      </Container>
    </Container>
  );
};

export default PricingCalculatorCardDemo;
